import { SuggestIcon } from "@/pages/lp/prod-dev/icons";
import { TechChip } from "./TechChip";

/**
 * 30日で身に付くことの頭に置く言語名の札。見た目の決まりは TechChip と同じ (ロゴのある名前はロゴ付き、無い名前は字だけ)。
 * AI は技術のロゴを持たないので、頼みごとを言葉にする印 (SuggestIcon) を頭に付ける。
 * 札の線、字の大きさと色は置く節の className で渡す
 */
export function SkillChip({ name, className = "" }: { name: string; className?: string }) {
  if (name !== "AI") return <TechChip name={name} className={className} />;
  return (
    <span className={`inline-flex items-center gap-[0.4em] ${className}`} style={{ borderRadius: 999 }}>
      <SuggestIcon size={16} className="block h-[1.25em] w-[1.25em] shrink-0" />
      {name}
    </span>
  );
}
